import { Link, useHistory } from "react-router-dom";
import { Card, Table } from "antd";
import { useViewport } from "@bindeleddet/core/hooks";
import MobileTable from "components/MobileTable/MobileTable";
import { RegisteredStudentData } from "../AdminSingleEventPage";

interface Props {
  registeredStudentsData: RegisteredStudentData[];
  loading: boolean;
}

const DeregisteredStudents: React.FC<Props> = ({ registeredStudentsData, loading }) => {
  const { width } = useViewport();
  const history = useHistory();

  const columns = [
    {
      title: "#",
      dataIndex: "number",
      key: "number",
      sorter: false,
    },
    {
      title: "Navn",
      dataIndex: "name",
      key: "name",
      render: (name: string, record: RegisteredStudentData) => {
        return <Link to={`/admin/students/${record.id}`}>{name}</Link>;
      },
    },
    {
      title: "Brukernavn",
      dataIndex: "username",
      key: "username",
    },
    {
      title: "Linje",
      dataIndex: "study_programme_name",
      key: "study_programme",
    },
    {
      title: "Årstrinn",
      dataIndex: "year_level",
      key: "year_level",
    },
    {
      title: "Telefon",
      dataIndex: "mobile_number",
      key: "mobile_number",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Allergier",
      dataIndex: "allergies",
      key: "allergies",
    },
    {
      title: "Avmeldt",
      dataIndex: "created_at",
      key: "created_at",
      sorter: (a: RegisteredStudentData, b: RegisteredStudentData) =>
        new Date(a.created_at).getTime() - new Date(b.created_at).getTime(),
      render: (date: string) => {
        return new Date(date).toLocaleString("nb-NO", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        });
      },
    },
  ];

  return (
    <Card title="Avmeldte studenter" style={{ width: "100%", marginTop: "16px" }}>
      {width > 768 ? (
        <Table
          style={{ width: "100%" }}
          dataSource={registeredStudentsData}
          columns={columns}
          pagination={false}
          loading={loading}
          locale={{ emptyText: loading ? "Laster inn avmeldte studenter..." : "Ingen avmeldte studenter" }}
        />
      ) : (
        <MobileTable
          data={registeredStudentsData}
          columns={[
            {
              title: "Navn",
              dataIndex: "name",
              key: "name",
            },
            {
              title: "Linje",
              dataIndex: "study_programme_name",
              key: "study_programme",
            },
            {
              title: "Årstrinn",
              dataIndex: "year_level",
              key: "year_level",
            },
            {
              title: "Avmeldt",
              dataIndex: "created_at",
              key: "created_at",
              render: (date: unknown) => {
                if (!date || typeof date !== "string") return "";
                return new Date(date).toLocaleString("nb-NO", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                });
              },
            },
          ]}
          loading={loading}
          onClick={id => history.push(`/admin/students/${id}/`)}
          emptyText="Ingen avmeldte studenter"
        />
      )}
    </Card>
  );
};

export default DeregisteredStudents;
